import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressRestaurantsPacingPoliciesOrderPacingPoliciesUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www.wixapis.com': [
      {
        srcPath: '/restaurants/order-pacing/v1/policies',
        destPath: '/v1/policies',
      },
      {
        srcPath: '/restaurants/v1/order-pacing-policies',
        destPath: '/v1',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/restaurants-order-pacing-policies',
        destPath: '/api',
      },
      {
        srcPath: '/order-pacing/v1/policies',
        destPath: '/v1/policies',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/restaurants-order-pacing-policies',
        destPath: '',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/restaurants-order-pacing-policies',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_restaurants_order-pacing-policy';

/**
 * Creates a new Policy
 * The default location id for the metaSite will be used if the location_id is not provided
 */
export function createPolicy(payload: object): RequestOptionsFactory<any> {
  function __createPolicy({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.order_pacing.v1.policy',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.pacing.policies.OrderPacingPolicies.CreatePolicy',
      packageName: PACKAGE_NAME,
      url: resolveComWixpressRestaurantsPacingPoliciesOrderPacingPoliciesUrl({
        protoPath: '/v1/policies',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __createPolicy;
}

/**
 * Get a Policy by location_id
 * The default location id for the metaSite will be used if the location_id is not provided
 */
export function getPolicy(payload: object): RequestOptionsFactory<any> {
  function __getPolicy({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.order_pacing.v1.policy',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.restaurants.pacing.policies.OrderPacingPolicies.GetPolicy',
      packageName: PACKAGE_NAME,
      url: resolveComWixpressRestaurantsPacingPoliciesOrderPacingPoliciesUrl({
        protoPath: '/v1/policies',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getPolicy;
}

/**
 * Update a Policy
 * The default location id for the metaSite will be used if the location_id is not provided
 * Pass the latest `revision` for a successful update
 */
export function updatePolicy(payload: object): RequestOptionsFactory<any> {
  function __updatePolicy({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.order_pacing.v1.policy',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.pacing.policies.OrderPacingPolicies.UpdatePolicy',
      packageName: PACKAGE_NAME,
      url: resolveComWixpressRestaurantsPacingPoliciesOrderPacingPoliciesUrl({
        protoPath: '/v1/policies/{policy.id}',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __updatePolicy;
}
